<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
let protocol = window.location.protocol; //协议
let host = window.location.host; //主机
let port = window.location.port;
let reg = /^localhost+/;
let reg1 = /^10\.0\.+/;
// if (reg.test(host)) {
//   //若本地项目调试使用
//   axios.defaults.baseURL = "https://download.cmgos.com/api/";
// } else {
//动态请求地址
axios.defaults.baseURL = protocol + "//" + host + "/api/";
// }
axios.defaults.timeout = 30000;
export default {
  name: "app",
  axios,
  created() {
    let host = window.location.host; //主机
    let reg = /cmop/gi;
    if (reg.test(host)) {
      this.$router.push({ name: "cmopLogin", params: { id: "cmop" } });
    }
  }
};
</script>

<style lang="scss">
@import "~@/style/style";
</style>



// WEBPACK FOOTER //
// src/App.vue